import React from 'react';
import FileInput from '../../components/Inputs/FileInput';
import Button from '../../components/landingPage/Button';

function BecomeAPartnerForm({ sendForm }) {

  const [userInfo, setUserInfo] = React.useState({
    name:"",
    email:"",
    phone_nb:"",
    message:"",
  })

  const [formSuccess, setFormSuccess] = React.useState(false);
  const [formError, setFormError] = React.useState({
    field: '',
    msg:''
  })

  // const handleCVUpload= (e) => {
  //   setUserInfo((prevState) => ({ ...prevState, cv: e.target.files[0] }));
  // }

  function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  const handleSubmit = () => {

    if (!userInfo.name) return setFormError({
      field: 'name',
      msg:  "Please add your name." 
    });
    if (!validateEmail(userInfo.email)) return setFormError({
      field: 'email',
      msg:  "Please add a valid email." 
    });
    if (!userInfo.phone_nb) return setFormError({
      field: 'phone_nb',
      msg:  "Please enter a valid phone number." 
    });
    setFormError({
      field: '',
      msg: ''
    })
    sendForm(userInfo);
    setFormSuccess(true);
    setUserInfo({
      name:"",
      email:"",
      phone_nb:"",
      message:"",
      cv: null
    });
    setTimeout(() => {
      setFormSuccess(false);
    }, 5000);
  }

  return (
    <div className="flex flex-col items-center p-8 w-full max-w-3xl text-center mx-auto text-lg">
      <div className="flex flex-col w-full max-w-3xl my-4">
        <h1 className="text-2xl font-bold my-2">Become a Partner</h1>
        <p>Please send us a message with your availability and personal information and one of our staff members will get in touch with you as soon as possible to set up an appointment.</p>
      </div>
      <div className="flex flex-col gap-4 pb-6 w-full max-w-6xl">
        <input type="text" label="name" placeholder="Name" className="placeholder-lpGray px-4 mt-2 h-10 bg-bgGray rounded" value={userInfo.name} onChange={(e) => {setUserInfo((prevState)=> ({...prevState, name:e.target.value}))}}></input>
        {formError.field === 'name' && 
        <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
        }
        <input type="email" label="email" placeholder="Email" className="placeholder-lpGray px-4 mt-2 h-10 bg-bgGray rounded" value={userInfo.email} onChange={(e) => {setUserInfo((prevState)=> ({...prevState, email:e.target.value}))}}></input>
        {formError.field === 'email' && 
        <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
        }
        <input type="phone_nb" label="phone_nb" placeholder="Phone number" className="placeholder-lpGray px-4 mt-2 h-10 bg-bgGray rounded" value={userInfo.phone_nb} onChange={(e) => {setUserInfo((prevState)=> ({...prevState, phone_nb:e.target.value}))}}></input>
        {formError.field === 'phone_nb' && 
        <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
        }
        <textarea label="message" placeholder="Please write here your availability" rows="4" className="message placeholder-lpGray resize-none px-4 py-2 mt-2 bg-bgGray rounded" value={userInfo.message} onChange={(e) => {setUserInfo((prevState)=> ({...prevState, message:e.target.value}))}}></textarea>
        {formError.field === 'message' && 
        <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
        }
        {/* <FileInput resetFiles={formSuccess} buttonText="Upload your CV" className="self-start" right handleFileUpload={handleCVUpload} accept="application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf"/>
        {formError.field === 'cv' && 
        <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
        } */}
        <Button text="Submit" className="w-full mt-2" onClick={()=>{handleSubmit()}}/>
      {formSuccess && 
      <span className="text-green-600 text-sm col-span-4">Message sent successfully!</span>
      }
      </div>
    </div>
  )
}


export default BecomeAPartnerForm;
